import JNJModule from './JNJModule';

export default JNJModule;
